import { pgTable, text, boolean, timestamp, integer, index, uniqueIndex, foreignKey, jsonb } from 'drizzle-orm/pg-core';
import { sql } from 'drizzle-orm';
import { user } from './user';
import { adminUser } from './admin';
import { adminAiMessageRole, aiChatStatus } from './enums';

export const aiChatLog = pgTable('AiChatLog', {
  id: integer().primaryKey().generatedAlwaysAsIdentity(),
  userId: integer(),
  prompt: text().notNull(),
  response: text().notNull(),
  // Аналитика работы агента (типизированные колонки для SQL-агрегации):
  status: aiChatStatus(),                 // исход: success/error/rate_limited/...
  model: text(),                          // id модели OpenRouter
  latencyMs: integer(),                   // длительность обработки запроса
  promptTokens: integer(),                // usage.prompt_tokens (nullable: free-модели не всегда отдают)
  completionTokens: integer(),            // usage.completion_tokens
  totalTokens: integer(),                 // usage.total_tokens
  errorCode: text(),                      // код ошибки провайдера (для rate_limited/error)
  routerCategory: text(),                 // категория, выбранная Router Agent
  iterations: integer(),                  // число tool-итераций
  metadata: jsonb(),
  createdAt: timestamp({ precision: 3, mode: 'date' }).default(sql`CURRENT_TIMESTAMP`).notNull(),
}, (table) => [
  index('AiChatLog_createdAt_idx').using('btree', table.createdAt.asc().nullsLast()),
  index('AiChatLog_userId_idx').using('btree', table.userId.asc().nullsLast()),
  index('AiChatLog_status_idx').using('btree', table.status.asc().nullsLast()),
  index('AiChatLog_model_idx').using('btree', table.model.asc().nullsLast()),
  foreignKey({
    columns: [table.userId],
    foreignColumns: [user.id],
    name: 'AiChatLog_userId_fkey'
  }).onUpdate('cascade').onDelete('set null'),
]);

export const aiConfiguration = pgTable('AiConfiguration', {
  id: integer().primaryKey().generatedAlwaysAsIdentity(),
  key: text().notNull(),
  value: jsonb().notNull(),
  isActive: boolean().default(true).notNull(),
  createdAt: timestamp({ precision: 3, mode: 'date' }).default(sql`CURRENT_TIMESTAMP`).notNull(),
  updatedAt: timestamp({ precision: 3, mode: 'date' }).notNull(),
}, (table) => [
  uniqueIndex('AiConfiguration_key_key').using('btree', table.key.asc().nullsLast()),
]);

// Admin AI Chats - сессии чатов админов с AI агентом
export const adminAiChat = pgTable('AdminAiChat', {
  id: integer().primaryKey().generatedAlwaysAsIdentity(),
  adminId: integer().notNull(),
  title: text(), // Автогенерируется из первого сообщения
  isArchived: boolean().default(false).notNull(),
  createdAt: timestamp({ precision: 3, mode: 'date' }).default(sql`CURRENT_TIMESTAMP`).notNull(),
  updatedAt: timestamp({ precision: 3, mode: 'date' }).notNull(),
}, (table) => [
  index('AdminAiChat_adminId_idx').using('btree', table.adminId.asc().nullsLast()),
  index('AdminAiChat_createdAt_idx').using('btree', table.createdAt.asc().nullsLast()),
  foreignKey({
    columns: [table.adminId],
    foreignColumns: [adminUser.id],
    name: 'AdminAiChat_adminId_fkey'
  }).onUpdate('cascade').onDelete('cascade'),
]);

// Admin AI Messages - сообщения в чатах
export const adminAiMessage = pgTable('AdminAiMessage', {
  id: integer().primaryKey().generatedAlwaysAsIdentity(),
  chatId: integer().notNull(),
  role: adminAiMessageRole().notNull(), // 'user' | 'assistant' | 'tool'
  content: text(), // Может быть null для assistant с tool_calls
  toolCalls: jsonb(), // Для assistant: [{id, name, arguments}]
  toolCallId: text(), // Для tool: id вызова
  toolName: text(), // Для tool: название инструмента
  metadata: jsonb(), // model, tokens, duration, etc.
  // Для веток (branching): id родительского сообщения
  parentId: integer(), // null для корневых сообщений
  // Индекс ветки - когда есть несколько ответов на одно сообщение
  branchIndex: integer().default(0).notNull(),
  // Активная ли эта ветка (для показа по умолчанию)
  isActive: boolean().default(true).notNull(),
  createdAt: timestamp({ precision: 3, mode: 'date' }).default(sql`CURRENT_TIMESTAMP`).notNull(),
}, (table) => [
  index('AdminAiMessage_chatId_idx').using('btree', table.chatId.asc().nullsLast()),
  index('AdminAiMessage_createdAt_idx').using('btree', table.createdAt.asc().nullsLast()),
  index('AdminAiMessage_parentId_idx').using('btree', table.parentId.asc().nullsLast()),
  foreignKey({
    columns: [table.chatId],
    foreignColumns: [adminAiChat.id],
    name: 'AdminAiMessage_chatId_fkey'
  }).onUpdate('cascade').onDelete('cascade'),
]);
